import { CheckCircle2, FileText, Lock, PenLine, Video, type LucideIcon } from "lucide-react"

export type LessonType = "video" | "reading" | "assignment"

const LESSON_TYPE_ICON: Record<LessonType, LucideIcon> = {
  video: Video,
  reading: FileText,
  assignment: PenLine,
}

const LESSON_TYPE_COLOR_CLASS: Record<LessonType, string> = {
  video: "text-primary",
  reading: "text-sky-400",
  assignment: "text-violet-400",
}

function isLessonType(value?: string | null): value is LessonType {
  return value === "video" || value === "reading" || value === "assignment"
}

export function getLessonTypeVisual(
  lesson: { lesson_type?: string | null },
  state: { completed?: boolean; accessible?: boolean } = {},
): { icon: LucideIcon; colorClass: string } {
  if (state.completed) {
    return { icon: CheckCircle2, colorClass: "text-emerald-500" }
  }
  if (state.accessible === false) {
    return { icon: Lock, colorClass: "text-muted-foreground" }
  }

  const type = isLessonType(lesson.lesson_type) ? lesson.lesson_type : "video"
  return { icon: LESSON_TYPE_ICON[type], colorClass: LESSON_TYPE_COLOR_CLASS[type] }
}
